import httpService from "./httpService";
import utils from "./utils";

export default {

  get: function () {
    return httpService.get("user", null);
  },

  update(id, form) {
    return httpService.put(`/user/${id}`, form)
  },
  save(form) {
    return httpService.post(`/user`, form)
  },
  delete(id) {
    return httpService.delete("/user/" + id);
  },
  findAll() {
    return httpService.get(`/user/findAll`)
  },
  findall(example, pageable) {
    pageable = utils.initPageableParams(pageable);
    var params = utils.merge(example, pageable);
    return httpService.get(`/user`, {params: params});
  },
  findById(id) {
    return httpService.get("/user/" + id);
  },
  changeStatus(id, form) {
    return httpService.put(`/user/${id}/changeStatus`, form);
  },
  findByUsername(username) {
    return httpService.get("/user/sso/" + username);
  },
  changePassword(id, form) {
    return httpService.put(`/user/${id}/changePassword`, form);
  },
  findByDeptId: function (deptId) {
    return httpService.get(`/user/findByDeptId/${deptId}`, null);
  },
  logoutAllApp() {
    return httpService.get(`/user/logoutAllApp`);
  }
}




// WEBPACK FOOTER //
// ./src/services/userService.js